import { request } from './index';
import { UserType } from './user';

export type StudentType = {
  id: number;
  user: UserType;
};

export async function fetchStudent(): Promise<StudentType> {
  return await request(true, { url: '/students/student' });
}

export type CreateStudentDataType = { notify: boolean | null };

export async function createStudent(data: CreateStudentDataType): Promise<StudentType> {
  return await request(true, {
    url: '/students/students',
    method: 'POST',
    data
  });
}

export type UpdateStudentDataType = { iban: string };

export async function updateStudent(data: UpdateStudentDataType): Promise<StudentType> {
  return await request(true, {
    url: '/students/student',
    method: 'PATCH',
    data
  });
}
